import { Errors, SDK } from 'goodt-dremio-sdk';
import { Const } from '@goodt-wcore/core';
import { RequestCancel } from '@goodt-wcore/errors';
import { DremioError, DremioPresentableError, DremioErrorMessages } from './errors';

/**
 *
 * @param {Error} error
 * @param {string} [humanReadableMessage]
 * @return {DremioPresentableError}
 */
const handleError = (error, { humanReadableMessage } = {}) => {
    // if is transport cancel request / abort signal error type
    // then not create global error
    if (error instanceof Errors.SDKCancelRequestError) {
        // eslint-disable-next-line better-mutation/no-mutating-functions
        return new RequestCancel(DremioErrorMessages.CANCEL);
    }

    const dremioError = DremioError.createFromSDKError(error);

    setTimeout(() => {
        throw dremioError;
    });

    return DremioPresentableError.createFromDremioError(dremioError, { message: humanReadableMessage });
};

/**
 * Dremio sdk factory
 *
 * @param {import('goodt-dremio-sdk').SDKConfig} config
 * @return {SDK}  sdk instance
 */
export const create = (config = {}) => {
    const { baseURL: host, ...restConfig } = config;
    try {
        const dremio = new SDK({
            host,
            /**
             * @param {import('axios').AxiosRequestConfig} axiosRequestConfig
             * @return {Promise<void>}
             */
            beforeRequest: async (axiosRequestConfig) => {
               const { AuthManager } = await import('@goodt-wcore/managers');
                const { adapter } = AuthManager.instance;
                if (adapter == null) {
                    return;
                }
                try {
                    await adapter.updateToken();
                    axiosRequestConfig.headers.Authorization = `Bearer ${adapter.token}`;
                    axiosRequestConfig.headers[Const.LICENSE_TOKEN_HEADER_KEY] = adapter.license;
                    dremio.config.authToken = adapter.token;
                } catch {
                    /* */
                }
            },
            processResponseError: handleError,
            processResponseResult: ({ rows, ...result }) => ({ ...result, rows: rows.map(Object.freeze) }),
            ...restConfig
        });

        return dremio;
    } catch (error) {
        throw handleError(error, {
            humanReadableMessage: 'Dremio instance creation error'
        });
    }
};

export const optionsSchema = {
    baseURL: window.location.origin
};
